import { useQuery } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

interface TempSamplesData {
  id: number;
  sampleId: string;
  version: number;
  changeBy: string;
  comment: boolean;
  delFlag: number;
  validFlag: number;
  mailCategory: string;
  formatCorrected: string;
  samplingMethod: string;
  netOrGrossAccounting: string;
  samplingRate: string;
  samplingDate: string | null;
  subsampleRate: string;
  sendingPpo: string;
  oeFromCode: string;
  receivingPpo: string;
  oeToCode: string;
  receptacleNumber: string;
  despatchNumber: string;
  despatchDate: string | null;
  despatchMailSubclass: string;
  grossKg: string;
  tareKg: string;
  netKg: string;
  labelWeight: string;
  ibrsKg: string;
  pkg: string;
  gkg: string;
  ekg: string;
  ckg: string;
  pitems: number | null;
  gitems: number | null;
  eitems: number | null;
  citems: number | null;
  receptacleType: string;
  receptacleCategory: string;
  receptacleMailSubclass: string;
  rplusV: string;
  fbag: string;
  stratum: string;
  receivedWeightStratum: string;
  sampledWeightStratum: string;
  effectiveSamplingRateStratum: string;
  receivedReceptaclesStratum: string;
  barcode: string;
  formatAnnounced: string;
  sampleStatus?: string;
  asi?: boolean;
}

interface TempSamplesResponse {
  content: TempSamplesData[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalElements: number;
  totalPages: number;
  first: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  empty: boolean;
}

interface UseTempSamplesDataParams {
  eno1FileId: number;
  page?: number;
  size?: number;
  sort?: string;
  direction?: 'ASC' | 'DESC';
  searchColumn?: string;
  searchTerm?: string;
  enabled?: boolean;
}

const fetchTempSamplesData = async (params: UseTempSamplesDataParams): Promise<TempSamplesResponse> => {
  const queryParams = new URLSearchParams();
  
  if (params.page !== undefined) queryParams.set('page', params.page.toString());
  if (params.size !== undefined) queryParams.set('size', params.size.toString());
  if (params.sort) queryParams.set('sort', params.sort);
  if (params.direction) queryParams.set('direction', params.direction);
  if (params.searchColumn) queryParams.set('searchColumn', params.searchColumn);
  if (params.searchTerm) queryParams.set('searchTerm', params.searchTerm);
  
  const response = await axios<TempSamplesResponse>({
    url: `/sampling-planning/temp-samples/eno1?eno1FileId=${params.eno1FileId}&${queryParams.toString()}`,
    method: 'GET',
  });
  
  return response.data;
};

export const useTempSamplesData = (params: UseTempSamplesDataParams) => {
  return useQuery({
    queryKey: ['tempSamplesData', params.eno1FileId, params.page, params.size, params.sort, params.direction, params.searchColumn, params.searchTerm],
    queryFn: () => fetchTempSamplesData(params),
    enabled: params.enabled !== false && params.eno1FileId > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export type { TempSamplesData, TempSamplesResponse, UseTempSamplesDataParams };
